import React from 'react';
import './App.css';
import './CybersecurityDueDiligence.css';
import CybersecurityDueDiligenceTool from './CybersecurityDueDiligenceTool';

function App() {
  return (
    <div className="App">
      <CybersecurityDueDiligenceTool />
    </div>
  );
}

export default App;
